@if (showView) {
<ndt-add-extension-view
   [callState]="callState | async"
   [extensionPrivileges]="extensionPrivileges$ | async"
   [form]="form"
   [extension]="extension"
   [accountId]="accountId | async"
   [extensionsForAdd]="extensionsForAdd"
   [externalNumbers]="externalNumbers"
   [extensionGroupsForAdd]="extensionGroupsForAdd"
   [timeZoneId]="timeZoneId | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate($event)"
>
</ndt-add-extension-view>
}
